import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { FeatureFlagsService } from '../services/feature-flags.service';
import { ROTAS_COM_FLAGS } from '../config/feature-flags.config';

export const FeatureFlagGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
) => {
  const featureFlagsService = inject(FeatureFlagsService);
  const router = inject(Router);

  const featureFlag = route.data['featureFlag'] as string | undefined;

  if (!featureFlag) {
    return true;
  }

  await featureFlagsService.aguardarCarregamento();

  const estaHabilitado = featureFlagsService.estaHabilitado(featureFlag);

  if (!estaHabilitado) {
    const rotaAlternativa = encontrarRotaHabilitada(
      featureFlagsService,
      featureFlag,
    );

    if (rotaAlternativa) {
      router.navigate([rotaAlternativa]);
    } else {
      router.navigate(['/login']);
    }

    return false;
  }

  return true;
};

function encontrarRotaHabilitada(
  featureFlagsService: FeatureFlagsService,
  flagAtual: string,
): string | null {
  for (const { rota, flag } of ROTAS_COM_FLAGS) {
    if (flag !== flagAtual && featureFlagsService.estaHabilitado(flag)) {
      return rota;
    }
  }
  return null;
}
